<div class="profession-search">
  <div class="profession-search__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'professions.search.hero_title' | translate }}</h1>

      <div class="profession-search__form">
        <div class="profession-search__field">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
          </svg>
          <div class="profession-search__field-content">
            <label>{{ 'shared.what' | translate }}</label>
            <input type="text" [(ngModel)]="searchBeroep" [placeholder]="'professions.search.placeholder' | translate" />
          </div>
          <button *ngIf="searchBeroep" class="profession-search__clear" (click)="clearSearch()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6 6 18"/><path d="m6 6 12 12"/>
            </svg>
          </button>
        </div>
        <button class="profession-search__submit" (click)="search()">{{ 'shared.search' | translate }}</button>
      </div>

      <p class="profession-search__results" *ngIf="hasSearched && searchBeroep">
        {{ 'professions.search.results_prefix' | translate }} <strong>{{ searchBeroep }}</strong>: {{ professions.length }}
      </p>
    </div>
  </div>

  <div class="profession-search__filters-bar">
    <div class="vacancy-container">
      <div class="vacancy-filters" style="grid-template-columns: repeat(2, 1fr);">
        <div>
          <label class="vacancy-filters__label">{{ 'shared.field_of_study' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="vakgebiedOptions"
            [control]="vakgebiedControl"
            [placeholder]="'shared.all_fields' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onVakgebiedSelected($event)"
          ></lib-single-select-search>
        </div>
        <div>
          <label class="vacancy-filters__label">{{ 'shared.education_level' | translate }}</label>
          <lib-single-select-search
            class="vacancy-filters__select"
            [options]="opleidingsniveauOptions"
            [control]="opleidingsniveauControl"
            [placeholder]="'shared.all_levels' | translate"
            [myFloatLabel]="'never'"
            [forceControl]="true"
            [setControlValue]="true"
            [forceControlByOptions]="true"
            [disabledTyping]="true"
            [disableSearchOptionFiltering]="true"
            (changed)="onOpleidingsniveauSelected($event)"
          ></lib-single-select-search>
        </div>
      </div>
    </div>
  </div>

  <div class="vacancy-container profession-search__content">
    <div class="vacancy-grid">
      <bwc-profession-card
        *ngFor="let profession of visibleProfessions"
        [profession]="profession"
        [isLiked]="isLiked(profession.id)"
        (liked)="toggleLike($event)"
      ></bwc-profession-card>
    </div>

    <div class="vacancy-load-more" *ngIf="hasMore">
      <button (click)="loadMore()">{{ 'shared.load_more' | translate }}</button>
    </div>
  </div>
</div>
